module.exports = __webpack_public_path__ + "img/w.a5798dc6.jpg";